import { UsageType } from "../validations";
import { useDataUsage } from "../hooks";
import moment from "moment";


export const defaultValueUsage = (value: Partial<ReturnType<typeof useDataUsage>["data"]> = {}): UsageType => ({
    coa_asset_id: value?.coa_asset_id?.toString() || "",
    coa_disposal_id: value?.coa_disposal_id?.toString() || "",
    date_disposal: value?.disposal_date || moment().format("YYYY-MM-DD"),
    net_book_value: value?.betbook || 0,
    memo: value?.disposal_memo || ""
});
